export /** Not really a hook */
function useScrollIntoView() {
  const scroller = (selector: string) => {
    if (document) {
      const selectedElement = document.querySelector(selector);
      if (selectedElement !== null) {
        selectedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };
  return scroller;
}
